import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import MotionErrorDialog from "src/modules/motion-detection/components/MotionErrorDialog";
import { getAppValue } from "src/utils/environment";
import SvgContainer from "src/components/SvgContainer";
import Container from "./components/Container";

import { ReactComponent as MotionBaby } from "src/modules/baby-station/components/MotionButton/motion-baby.svg";
import { ReactComponent as MotionDog } from "src/modules/baby-station/components/MotionButton/motion-dog.svg";
import { ReactComponent as ErrorIcon } from "src/modules/baby-station/components/MotionButton/motion-error.svg";
import getColors from "./getColors";

export default function MotionError({
  isDarkMode,
  error,
  mode,
  activity,
  isParentStation,
  motionDetectorState,
  ...rest
}) {
  const [motionErrorDialog, setMotionErrorDialog] = useState({
    isOpen: false,
    open: () =>
      setMotionErrorDialog((prevState) => ({ ...prevState, isOpen: true })),
    close: () =>
      setMotionErrorDialog((prevState) => ({ ...prevState, isOpen: false }))
  });

  const { bg, color } = getColors({ isDarkMode, activity, mode, error });
  return (
    <>
      <MotionErrorDialog
        isParentStation={isParentStation}
        motionDetectorState={motionDetectorState}
        isOpen={motionErrorDialog.isOpen}
        onClose={motionErrorDialog.close}
      />
      <Container
        onClick={motionErrorDialog.open}
        p={["6px 12px", "8px 16px"]}
        bg={bg}
        {...rest}
      >
        <Flex width="28px" justifyContent="center" position="relative">
          <SvgContainer
            icon={getAppValue({
              bibino: MotionBaby,
              barkio: MotionDog
            })}
            size="16px"
            fill={color}
          />
          <Box
            transform="scale(0.6)"
            position="absolute"
            bottom="-45%"
            left="35%"
          >
            <ErrorIcon />
          </Box>
        </Flex>
      </Container>
    </>
  );
}
